import { render, staticRenderFns } from "./CardTitleWithBackButton.vue?vue&type=template&id=498c4292&scoped=true&"
import script from "./CardTitleWithBackButton.vue?vue&type=script&lang=js&"
export * from "./CardTitleWithBackButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498c4292",
  null
  
)

export default component.exports